import { DO_ACTION, IDENTIFIER } from '../actions';
import { ListReducerBuilder, ReducerSet } from '../../../../utils/reducers';
import { IBaseState } from '../../../../utils/reducers/IBaseState';
import { IAwardApplication } from '../../../../core/interfaces/model';

interface IAwardApplicationsState extends IBaseState {
    data: IAwardApplication[];
}

const listReducerBuilder = new ListReducerBuilder(IDENTIFIER, false, false, false)
    .addReducerSet(ReducerSet.create(
        DO_ACTION,
        (state: IAwardApplicationsState, payload: IAwardApplication) => ({
            ...state,
            pending: false,
            data: (state.data || []).map(a => a.id === payload.id ? payload : a),
            error: null
        })
    ));

export default {
    awardApplications: listReducerBuilder.build()
};
